import { bindOverflowCarousel } from '@theme/bt-scroll-carousel';

/**
 * PDP fabric & technology — key-benefits overflow row.
 * Progress + hover prev/next; accordion open refreshes chrome after the track is visible.
 */
class BtPdpFabric extends HTMLElement {
  /** @type {import('./bt-scroll-carousel').OverflowCarouselBinding | null} */
  #carousel = null;

  /** @type {HTMLDetailsElement | null} */
  #details = null;

  connectedCallback() {
    const track = this.querySelector('[data-bt-fabric-track]');
    if (!(track instanceof HTMLElement)) return;

    this.#carousel = bindOverflowCarousel({
      root: this,
      track,
      prevButton: this.querySelector('[data-bt-fabric-prev]'),
      nextButton: this.querySelector('[data-bt-fabric-next]'),
      cardSelector: '.bt-pdp-fabric__card',
      progressVar: '--bt-fabric-progress',
      features: { progress: true, nav: true },
    });

    const details = this.closest('details');
    if (details instanceof HTMLDetailsElement) {
      this.#details = details;
      details.addEventListener('toggle', this.#onToggle);
    }
  }

  disconnectedCallback() {
    this.#details?.removeEventListener('toggle', this.#onToggle);
    this.#details = null;
    this.#carousel?.disconnect();
    this.#carousel = null;
  }

  #onToggle = () => {
    this.#carousel?.update();
  };
}

if (!customElements.get('bt-pdp-fabric')) {
  customElements.define('bt-pdp-fabric', BtPdpFabric);
}
